import {FilenameUtil, UIUtil, Util} from 'yougile-util'
import {ChatMessage} from 'yougile-model'
import {Backend} from '@common/backend'
import {ChatMessageFile} from '@components/common/base/chat-message'

export const extractAllFiles = (message: ChatMessage): ChatMessageFile[] =>
  message.getLinksForAttachments().map(encoded => {
    const href = FilenameUtil.absoluteUrlFromEncoded(encoded)
    const fileName = Util.safeDecodeUriComponent(
      ' ' + href.split('?').shift()?.split('/').pop()
    )
    return {encoded, href, fileName, url: Backend.toDataUrl(href)}
  })

export const extractFiles = (message: ChatMessage): ChatMessageFile[] =>
  extractAllFiles(message).filter(x => !UIUtil.isImageName(x.fileName))
